import {BookingType} from "../../../models/payment/booking-type";
import {ObjectDescription} from "./_enums/object-description";
import {BusinessCaseType} from "./_enums/business-case-type";
import {VATRate} from "../../../models/common/vat-rate";

/**
 * A business case as the web posts it (`PUT Device/CashPointEntry/Close`). The server's
 * `Shared.Core.Models.Booking.BusinessCaseInformation` reads the same fields. `amount` is the signed money of a
 * counted-cash movement (negative out of the drawer, positive into it) and `quantity` is +1 for the operation
 * (#820); −1 marks a reversal and is never posted by the web.
 */
export class BusinessCaseInformation {
  bookingType: BookingType = BookingType.Cash;
  amount: number = 0;
  objectDescription: ObjectDescription = ObjectDescription.None;
  comment: string | null = null;
  type: BusinessCaseType = BusinessCaseType.Umsatz;
  vatRate: VATRate = VATRate.NULL;
  quantity: number = 1;

  constructor(bookingType: BookingType,
              amount: number,
              objectDescription: ObjectDescription,
              comment: string | null,
              businessCaseType: BusinessCaseType,
              vatRate: VATRate,
              quantity: number = 1) {
    this.bookingType = bookingType;
    this.amount = amount;
    this.objectDescription = objectDescription;
    this.comment = comment;
    this.type = businessCaseType;
    this.vatRate = vatRate;
    this.quantity = quantity;
  }
}
